// extracted by mini-css-extract-plugin
export default {"pencilIcon":"PencilButton_pencilIcon__oK005"};